import styled from "styled-components";

import awardBg from '@/images/day-award-box.png'
import awardBgHover from '@/images/day-award-box-hover.png'

const View = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 520px;
  height: 470px;
  padding-top: 92px;
  padding-left: 34px;

  div.taskItem {
    position: relative;
    height: 86px;
    width: 100%;

    & > p {
      vertical-align: top;
      width: 130px;
      line-height: 86px;
      text-align: center;
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 0 0 2px #1a53b5;
    }

    ul {
      text-align: center;
      display: inline-block;
      position: relative;
      top: 50%;
      transform: translateY(-50%);

      li {
        display: inline-block;
        width: 72px;
        height: 76px;
        position: relative;
        background-image: url("${awardBg}");
        cursor: pointer;
        transition: all 0.15s;
        margin: 0 4px;

        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
        }

        &.normal {
          &:hover {
            background-image: url("${awardBg}");
          }
        }

        img {
          width: 44px;
          height: 45px;
          position: absolute;
          left: 50%;
          top: 7px;
          transform: translateX(-50%);
        }

        p {
          color: #1a53b5;
          font-weight: bold;
          position: absolute;
          bottom: 3px;
          width: 100%;
          font-size: 12px;
        }
      }
    }
  }

  p.tip {
    cursor: pointer;
    position: absolute;
    bottom: 5px;
    left: 0;
    padding: 0 40px;
    width: 100%;
    font-size: 14px;
    line-height: 28px;

    span:nth-child(1) {
      color: #ffffff;
      float: left;
    }

    span:nth-child(2) {
      float: right;
      text-decoration: underline;
      color: #fdec82;
    }
  }

  .button {
    margin-left: 6px;
  }
`;

export {
  View
}
